import { Outlet, useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyQuoteBar from "@/components/StickyQuoteBar";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Layout() {
  const { pathname } = useLocation();
  const hideBar = pathname.startsWith("/admin");
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1 pb-16 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      {!hideBar && <StickyQuoteBar />}
      {!hideBar && <WhatsAppButton />}
    </div>
  );
}
